
// Extracts and returns the initials from a full name.
export function getUserInitials(name:string = "") {
  const parts = String(name).trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "U";
}

// Safely formats different timestamp formats into a localized string.
export function formatTimestamp(ts: any) {
  if (!ts) return "—";
  try {
    if (ts?.toDate) return ts.toDate().toLocaleString();
    if (typeof ts === "string") return new Date(ts).toLocaleString();
    if (ts instanceof Date) return ts.toLocaleString();
  } catch {}
  return "—";
}